import { useEffect } from 'react'
import { when } from 'mobx'
import { observer } from 'mobx-react-lite'
import { uiStore } from 'shared/store/uiStore'
import { FeatureRestrictedModalStore } from 'entities/UsersPermissions'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { contactsDetailsGlobalStore } from 'widgets/ContactsDetails/store'
import { useContactsPageContext } from 'pages/contacts/context/contactsPageContext'
import { ContactsRoutes } from '../type'

export const NewContactRoute = observer(() => {
  const { contactsTableStore } = useContactsPageContext()
  const { userPermissionsStore } = useEntitiesContext()
  const allPath = `/${ContactsRoutes.root}/${ContactsRoutes.all}`

  useEffect(() => {
    let frame = 0
    let disposeOpen: (() => void) | null = null

    // Permissions load async; wait so a permitted user is not wrongly gated.
    const disposePermission = when(
      () => !userPermissionsStore.loading,
      () => {
        if (!userPermissionsStore.getItem('can_create_contacts')) {
          new FeatureRestrictedModalStore('can_create_contacts', () =>
            uiStore.changeRoute({ path: allPath, method: 'replace' })
          )

          return
        }

        // Defer past the list load + a paint so the phone autofocus is not stolen.
        frame = requestAnimationFrame(() => {
          disposeOpen = when(
            () => !contactsTableStore.isLoading,
            () => {
              frame = requestAnimationFrame(() => {
                contactsTableStore.addNewContactManually()
                contactsDetailsGlobalStore.handleChangeCollapse(false)
              })
            }
          )
        })
      }
    )

    return () => {
      disposePermission()
      disposeOpen?.()
      cancelAnimationFrame(frame)
      contactsTableStore.resetNewContactMode({ reload: false })
    }
  }, [])

  return null
})
